const CENTINELA_ERROR_KEYS: Record<string, string> = {
  plan_no_incluye_centinela: "monitoreoIa.errors.planNoIncluye",
  tope_alcanzado: "monitoreoIa.errors.topeAlcanzado",
  sin_telefono_de_operador: "monitoreoIa.errors.sinTelefonoOperador",
  voz_desconocida: "monitoreoIa.errors.vozDesconocida",
  numero_no_disponible: "monitoreoIa.errors.numeroNoDisponible",
  alerta_desconocida: "monitoreoIa.errors.alertaDesconocida",
  sin_cambios: "monitoreoIa.errors.sinCambios",
  validacion: "monitoreoIa.errors.validacion",
};

const STATUS_KEYS: Record<number, string> = {
  402: "monitoreoIa.errors.planNoIncluye",
  502: "monitoreoIa.errors.upstream",
  503: "monitoreoIa.errors.notConfigured",
  504: "monitoreoIa.errors.timeout",
};

interface CentinelaErrorShape {
  response?: {
    status?: number;
    data?: { meta?: { message?: string } };
  };
}

export function centinelaErrorCode(error: unknown): string {
  return (error as CentinelaErrorShape)?.response?.data?.meta?.message ?? "";
}

export function centinelaErrorKey(error: unknown, fallbackKey: string): string {
  const response = (error as CentinelaErrorShape)?.response;
  const byCode = CENTINELA_ERROR_KEYS[centinelaErrorCode(error)];
  if (byCode) return byCode;

  const status = response?.status;
  return (status && STATUS_KEYS[status]) || fallbackKey;
}
